module.exports = __webpack_public_path__ + "static/media/ExcelExport.a9e26ac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ExcelExport.png
// module id = 664
// module chunks = 0